/*
  Metric API request body/template
*/
import cloneDeep from 'lodash/cloneDeep';
import { DATASET } from '@utils/constants';
import { DEFAULT_KPI_ID } from '@src/utils/kpi';

export const query = {
  type: 'timeseries',
  dataset: DATASET,
  metrics: [],
  interval: '2021-02-03T18:21:00-04:00/2021-02-04T00:21:44-04:00',
  granularity: 'PT1M',
  filter: [],
  options: {
    withTotals: true,
    withOverviewThresholds: true,
    kpiConfig: {},
  },
};

const initialState = {
  metric: '',
  query: null,
  response: null,
  chartData: null,
  isFetching: true,
  errorCode: 0,
  errorMsg: '',
  sort: 0,
  invalid: true,
  metricValue: {},
};

export const createMetric = (metric) => ({
  ...cloneDeep(initialState),
  metric,
});
